/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
/* Theme variables */
import './theme/variables.css';
import './theme/fonts.css';
import './theme/global.css';

import { Suspense, useEffect, useState } from 'react';

import { IonApp, IonSpinner, setupIonicReact } from '@ionic/react';

import {
  DebugStore,
  DebugStoreProvider,
  setupDebugStore,
} from './models/DebugStore/DebugStore';
import App from './App';

setupIonicReact();

const AppDebugger: React.FC = () => {
  const [debugStore, setDebugStore] = useState<DebugStore | undefined>(
    undefined
  );

  useEffect(() => {
    (async () => {
      setupDebugStore().then(setDebugStore);
    })();
  }, []);

  if (!debugStore) return null;

  return (
    <IonApp>
      <Suspense
        fallback={
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            <IonSpinner name="crescent" style={{ width: 48, height: 48 }} />
          </div>
        }
      >
        <DebugStoreProvider value={debugStore}>
          <App />
        </DebugStoreProvider>
      </Suspense>
    </IonApp>
  );
};
export default AppDebugger;
